module.exports = __webpack_public_path__ + "static/Financial-536c6d451eac8a00f5aa5cf154dc5118.pdf";